export default class Constants {
  public static YLocation: number = 256;
}
